import React from 'react';
import clx from 'classnames';
import { Collapse } from 'antd';
const { Panel } = Collapse;
import { CollapsePanelProps } from 'antd/lib/collapse';
import './CollapsablePanel.scss';

export interface CollapsablePanelProps extends CollapsePanelProps {
  children: React.ReactNode;
  isAdmin?: boolean;
  defaultOpened?: boolean;
}

export function CollapsablePanel(props: CollapsablePanelProps) {
  const {
    children,
    className,
    header,
    isAdmin,
    defaultOpened,
    ...otherProps
  } = props;
  return (
    <Collapse
      bordered={false}
      className={clx({
        'collapse-is-admin': isAdmin
      })}
      defaultActiveKey="top-panel"
    >
      <Panel
        header={header}
        className={clx('top-filter-panel', className, {
          'is-admin': isAdmin
        })}
        {...otherProps}
        key={defaultOpened ? 'top-panel' : 'generic'}
      >
        {children}
      </Panel>
    </Collapse>
  );
}
